import React, { useState,useEffect } from 'react';
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

const CustomDropdown = ({ data, selectedEventId, handleSelectChangeTheme }) => {
  useEffect(() => {
    // console.log("Updated data received by CustomDropdown:", data); // Debug updated data
  }, [data]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState("Select Event");

  const handleSelect = (item) => {
    setSelectedValue(`${item.event_name} - ${item.theme_name}`);
    handleSelectChangeTheme(item._id);
    setIsOpen(false);
  };

  return (
    <div className="dropdown" style={{ position: 'relative', }}>
      <div
        className="dropdown__selected"
        style={{
          padding: '10px',
          cursor: 'pointer',
          whiteSpace: "nowrap",
          width: "93%",
          display: "flex",
          justifyContent: "space-between",
          width:"93%",
          overflow:"hidden",
          textOverflow:"ellipsis",          
        }}
        onClick={() => setIsOpen(!isOpen)}

      >
        {selectedValue} <span style={{
          position:"absolute",
          top:10,
          right:5
        }}>{isOpen ? <FiChevronUp /> : <FiChevronDown />}</span>
      </div>

      {isOpen && (
        <ul
          className="dropdown__list"
          style={{
            position: 'absolute',
            top: '100%',
            left: '0',
            right: '0',
            maxHeight: '150px',
            overflowY: 'auto',
            border: '1px solid #ccc',
            backgroundColor: '#fff',
            listStyle: 'none',
            padding: '0',
            margin: '0',
            zIndex: '1000',
          }}
        >
          {data.map((item, index) => (
            <li
              key={index}
              onClick={() => handleSelect(item)}
              style={{
                padding: '10px',
                cursor: 'pointer',
                borderBottom: '1px solid #eee',
              }}
            >
              {item.event_name} - {item.theme_name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomDropdown;
